var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered"},[_c('img',{attrs:{"src":require('@/assets' + _vm.fileName),"alt":"dxbanksolutionslogo"}}),_c('p',{staticClass:"is-size-5",style:({color: 'rgb(255, 255, 255)'})},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }